import React from 'react';
import {FlatList, View} from 'react-native';
import Card from './Card/Card';
import {styles} from './styles';
import { IBrand } from '../../../../types/Filter';

interface IProductsButton {
  onPress: (val: string) => void;
  goToFavorites: () => void;
  brand: IBrand[];
}

const ProductsButton = ({onPress, goToFavorites, brand}: IProductsButton) => {
  const listProducts = [
    {
      name: 'Promoções',
    },
    {
      name: 'Coca-Cola',
    },
    {
      name: 'Heineken',
    },
    {
      name: 'Guaraná Jesus',
    },
    {
      name: 'Promoções',
    },
    {
      name: 'Coca-Cola',
    },
    {
      name: 'Heineken',
    },
    {
      name: 'Guaraná Jesus',
    },
  ];

  const renderItem = ({item, index}) => (
    <Card item={item} onPress={(val: string) => onPress(val)} />
  );

  return (
    <View style={styles.containerFlat}>
      <FlatList
        renderItem={renderItem}
        data={brand}
        horizontal
        keyExtractor={(item, index) => 'key' + index}
        showsHorizontalScrollIndicator={false}
      />
    </View>
  );
};

export default ProductsButton;
